import {urlApi, urlPath, get, } from '../api';

const url = urlApi + urlPath.webBanners

export const getData = async(token='', extra='') =>{
    return await get(url, token, extra)
}
